import { ReactElement } from 'react'
import { List, ListItem, ListItemText, Typography, Box, Tooltip } from '@mui/material'
import { getTaskTitle } from './taskTitles'

interface Props {
  runningTasks: RunningTask[]
}

const ServerTab = ({ runningTasks }: Props): ReactElement => {
  if (runningTasks.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary">
        Aktuell werden keine Aufgaben auf dem Server ausgeführt.
      </Typography>
    )
  }

  return (
    <List dense>
      {runningTasks.map(task => (
        <ListItem key={task.task_id} alignItems="flex-start">
          <ListItemText
            primary={
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Tooltip title={task.name}>
                  <Typography variant="subtitle2">{getTaskTitle(task.name)}</Typography>
                </Tooltip>
                <Typography variant="caption" color="info.main">
                  Läuft
                </Typography>
              </Box>
            }
            secondary={
              <Typography variant="caption" color="textSecondary">
                {task.worker}
              </Typography>
            }
          />
        </ListItem>
      ))}
    </List>
  )
}

export default ServerTab
